import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import Box from '@material-ui/core/Box';
import format from 'date-fns/format';
import Pagination from '../../../components/Pagination/Pagination';
import CustomTable from '../../../components/Table/Table';
import Button from '../../../components/Button/CustomButton';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import SnackBar from '../../../components/Snackbar/Snackbar';
import LiveStreamDialog from '../../../containers/admin/LiveStreamManagement/LiveStreamDialog';

const ActionRow = ({ onEdit, onDelete, ...rest }) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
        <Button onClick={onEdit} style={{ fontSize: '14px' }} color="success" {...rest}>編集</Button>
        &nbsp;
        <Button onClick={onDelete} style={{ fontSize: '14px' }} color="danger" {...rest}>削除</Button>
    </Box>
);

const LiveStreamManagement = (props) => {
    const {
        fetchGetListLiveStream,
        fetchClearGetListLiveStream,
        dataListLiveStream,
        page,
        pageTotal,
        fetchClearDeleteLiveStream,
        fetchDeleteLiveStream,
        deleteSucces,
    } = props;
    const routeParams = useParams();
    const intl = useIntl();
    const [isOpenDialogUpdate, setIsOpenDialogUpdate] = useState(false);
    const [isOpenDialogDelete, setIsOpenDialogDelete] = useState(false);
    const [isOpenSnackBar, setIsOpenSnackBar] = useState({ isOpen: false, message: '', color: '' });
    const [liveStreamTable, setLiveStreamTable] = useState([]);
    const [liveStreamId, setLiveStreamId] = useState();

    useEffect(() => {
        fetchClearGetListLiveStream();
        return () => {
            fetchClearGetListLiveStream();
            fetchClearDeleteLiveStream();
        };
    }, []);

    useEffect(() => {
        if (routeParams || !isOpenDialogUpdate) {
            fetchGetListLiveStream({ event_name: routeParams.shortName });
        }
    }, [routeParams, isOpenDialogUpdate]);

    useEffect(() => {
        if (!_.isEmpty(deleteSucces) && !_.isEmpty(deleteSucces.data)) {
            setIsOpenSnackBar({ isOpen: true, message: 'ライブ配信を削除しました。', color: 'success' });
            fetchClearDeleteLiveStream();
            setIsOpenDialogDelete(false);
            fetchGetListLiveStream({ event_name: routeParams.shortName });
            setLiveStreamId(0);
        }
        if (!_.isEmpty(deleteSucces) && !_.isEmpty(deleteSucces.errors)) {
            setIsOpenDialogDelete(false);
            setIsOpenSnackBar({ isOpen: true, message: deleteSucces.errors.message.message, color: 'error' });
            setLiveStreamId(0);
            fetchClearDeleteLiveStream();
            fetchGetListLiveStream({ event_name: routeParams.shortName });
        }
    }, [deleteSucces]);

    useEffect(() => {
        if (!_.isEmpty(dataListLiveStream)) {
            const tableData = dataListLiveStream.map((livestream) => [
                livestream.title,
                livestream.speaker,
                livestream.dates.map((d) => <p>{format(new Date(d.date), 'yyyy/MM/dd')}</p>),
                <p>
                    {livestream.stime}
                    ~
                    {livestream.etime}
                </p>,
                livestream.cost === 0 ? '無料' : `${intl.formatNumber(livestream.cost)}円`,
                livestream.url_live_stream,
                <ActionRow onEdit={() => handleOpenDialogEditLiveStream(livestream.id)} onDelete={() => handleOpenDialogDeleteLiveStream(livestream.id)} size="sm" />,
            ]);
            setLiveStreamTable(tableData);
        } else {
            setLiveStreamTable([]);
        }
    }, [dataListLiveStream]);

    const handleOpenDialogEditLiveStream = (id) => {
        setLiveStreamId(id);
        setIsOpenDialogUpdate(true);
    };

    const handleCloseDialogEditLiveStream = () => {
        setLiveStreamId(0);
        setIsOpenDialogUpdate(false);
    };

    const handleOpenDialogDeleteLiveStream = (id) => {
        setLiveStreamId(id);
        setIsOpenDialogDelete(true);
    };

    const handleCloseDialogDeleteLiveStream = () => {
        setLiveStreamId(0);
        setIsOpenDialogDelete(false);
    };

    const handleDeleteLiveStream = () => {
        fetchDeleteLiveStream({
            event_name: routeParams.shortName,
            live_stream_id: liveStreamId,
        });
    };

    const handleSearchWithPage = (page) => {
        fetchGetListLiveStream({
            event_name: routeParams.shortName,
            page,
        });
    };

    return (
        <>
            <CustomTable
                onClick={() => {}}
                tableHead={['タイトル', '出演者', '日程', '時間帯', '有料・無料', 'ライブ配信を見るURL', '編集/削除']}
                tableHeadWidth={['10%', '10%', '10%', '10%', '10%', '10%', '10%']}
                tableData={liveStreamTable}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={page}
                            total={pageTotal}
                            onChange={(pageChange) => handleSearchWithPage(pageChange)}
                        />
                    </Box>
                )}
                pointerLess
            />

            <LiveStreamDialog
                isOpen={isOpenDialogUpdate}
                handleIsClose={handleCloseDialogEditLiveStream}
                liveStreamId={liveStreamId}
                eventName={routeParams.shortName}
                fetchList={() => fetchGetListLiveStream({ event_name: routeParams.shortName })}
            />

            <AlertDialog
                title={<FormattedMessage id="dialog.confirmDeleteTitle" />}
                handleClose={handleCloseDialogDeleteLiveStream}
                handleOpen={isOpenDialogDelete}
                handleSubmit={handleDeleteLiveStream}
                contents="削除しますか？"
            />

            <SnackBar
                open={isOpenSnackBar.isOpen}
                onClose={() => setIsOpenSnackBar({ isOpen: false, message: '', color: '' })}
                message={isOpenSnackBar.message}
                severity={isOpenSnackBar.color}
                autoHideDuration={3000}
            />

        </>
    );
};

ActionRow.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

LiveStreamManagement.defaultProps = {
    dataListLiveStream: [],
    page: 0,
    pageTotal: 0,
    deleteSucces: {},
};

LiveStreamManagement.propTypes = {
    fetchGetListLiveStream: PropTypes.func.isRequired,
    fetchClearGetListLiveStream: PropTypes.func.isRequired,
    dataListLiveStream: PropTypes.oneOfType([() => null, PropTypes.array]),
    page: PropTypes.number,
    pageTotal: PropTypes.number,
    fetchClearDeleteLiveStream: PropTypes.func.isRequired,
    fetchDeleteLiveStream: PropTypes.func.isRequired,
    deleteSucces: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default LiveStreamManagement;
